import React from "react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { IconPlus } from "@tabler/icons-react";

import BreadCrumbs from "@components/breadCrumbs/breadCrumbs";
import CustomTabs from "@components/tabs/customTabs";
import CustomButton from "@components/button/customButton";

import Newsletter from "./newsletter/newsletter";
import Subscriber from "./subscriber/subscriber";

export default function Broadcast() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  return (
    <div>
      <BreadCrumbs 
        rightSection={
          
          <CustomButton 
            component={RouterLink} 
            startIcon={<IconPlus size={13} />}
            to={tab !== "subscriber" ? 'create' : 'create-subscriber'} 
          >
            Create
          </CustomButton>
        }
      />
      <CustomTabs
        tabs={[
          {
            label: "Newsletter",
            value: "newsletter",
            component: (
              <Newsletter />
            ),
          },
          {
            label: "Subscriber",
            value: "subscriber",
            component: (
              <Subscriber />
            ),
          },
        ]}
      />
    </div>
  );
}